'use client';

import { c as _c } from "react/compiler-runtime";
import { Modal, type ModalProps } from '@repo/design-system/components/ui/modal';
import { useT } from '@repo/i18n/components/i18n.client';
import { MapEmbedContent } from './map-embed-content';
export const MapEmbedModal = t0 => {
  const $ = _c(8);
  const {
    isOpen,
    onOpenChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MapEmbedContent />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isOpen || $[5] !== onOpenChange || $[6] !== t2) {
    t4 = <Modal size="md" title={t2} isOpen={isOpen} onOpenChange={onOpenChange}>{t3}</Modal>;
    $[4] = isOpen;
    $[5] = onOpenChange;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
function _temp($) {
  return $.game_map_embed.embed_map;
}